// extracted by mini-css-extract-plugin
module.exports = {"jumpBarItem":"PageJumpBarItem-jumpBarItem-3F58I"};